import { openModal } from '@mantine/modals';
import { MODAL_SIZE_MEDIUM } from '@shared/ui/modal';
import {
  CANDIDATE_RESUME_DEACTIVATE_MODAL_ID,
  CandidateResumeDeactivateModalContent,
} from '../components/CandidateResumeDeactivateModalContent';

export const useCandidateResumeDeactivateModal = (
  onConfirm: () => Promise<boolean>
) => {
  const openCandidateResumeDeactivateModal = () => {
    openModal({
      modalId: CANDIDATE_RESUME_DEACTIVATE_MODAL_ID,
      title: 'Деактивировать профиль',
      size: MODAL_SIZE_MEDIUM,
      children: <CandidateResumeDeactivateModalContent onConfirm={onConfirm} />,
    });
  };

  return { openCandidateResumeDeactivateModal };
};
